import * as React from 'react';
import { connect } from 'react-redux';
import { IBasePageProps } from '../../configuration/IConfiguration';
import { bindActionCreators } from 'redux';
import * as LoginActionCreators from "../../../../actions/login.actions";
import Login from '../../../Users/Login';
import { IAppState } from '../../../../app';
import { Redirect } from 'react-router';
import { ErrorCodes } from '../../../../common/errorCodes';

interface IPageLoginProps {
    redirectEmailNotVerifiedRoute: string;
    title: string;
    registerRoute: string;

    loggingIn: boolean;
    loginError: any;
    login: typeof LoginActionCreators.login;
    logout: typeof LoginActionCreators.logout;
}

interface IPageLoginRouteParams {
}

interface IPageLoginQueryParams {
}

type PageLoginProps = IBasePageProps<IPageLoginRouteParams, IPageLoginQueryParams> & IPageLoginProps;

interface IPageLoginState {
    attemptedLogin: boolean;
}

class PageLogin extends React.Component<PageLoginProps, IPageLoginState> {
    constructor(props, context) {
        super(props, context);

        this.state = { attemptedLogin: false };
    }

    onLogin(username, password, rememberMe: boolean){
        this.setState({
            attemptedLogin: true
        });

        this.props.login(username, password, rememberMe);
    }

    render() {
        const { children, loginError, loggingIn, logout, redirectEmailNotVerifiedRoute, title  } = this.props;

        const errorRedirect = this.state.attemptedLogin && redirectEmailNotVerifiedRoute && loginError === ErrorCodes.EmailNotVerified
            ? <Redirect to={redirectEmailNotVerifiedRoute} />
            : undefined;

        return (
            <div className="mx-lg-3 mt-3 col-md-6 col-12">
                {errorRedirect}
                <h3>{title}</h3>
                <Login
                    loggingIn={loggingIn}
                    login={(username, password, rememberMe) => this.onLogin(username, password, rememberMe)}
                    logout={logout}
                    title={title}
                />
                <div className="text-center mt-3">
                    {children}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: PageLoginProps) => {

    return {
        loggingIn: state.user.loggingIn,
        loginError: state.user.loginError
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        login: LoginActionCreators.login,
        logout: LoginActionCreators.logout
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PageLogin);